<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="$l('table_label_search')"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <slot />
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      show-close
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form :model="form" size="small" label-width="100px">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_sampleSetStatus') || '有效状态'"
            >
              <el-checkbox-group v-model="form.listSampleSetStatus">
                <el-checkbox label="Y">
                  {{ $l('INDEX.form_label_new') || '新增' }}
                </el-checkbox>
                <el-checkbox label="S">
                  {{ $l('INDEX.form_label_reviewed') || '已审核' }}
                </el-checkbox>
                <el-checkbox label="N">
                  {{ $l('INDEX.form_label_deleted') || '已删除' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_sampleSetNo') || '样品款号'">
              <el-input
                v-model.trim="form.sampleSetNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_sampleSetName') || '样品名称'">
              <el-input
                v-model.trim="form.sampleSetName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_displayCategory') || '样品分类'"
            >
              <category-cascader
                v-model="form.categoryCode"
                :masterCategoryCode.sync="form.masterCategoryCode"
                :params="categoryParams"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_sampleSource') || '样品来源'">
              <dict-select
                v-model="form.listSampleSource"
                url="/master/common/dict/biz"
                :body="{ dictType: 'sampleSource' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_salesPerson') || '业务员'">
              <dict-select
                v-model="form.listSalesPersonCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                style="width: 100%"
                clearable
                filterable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_designer') || '设计师'">
              <dict-select
                v-model="form.listDesignerCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                style="width: 100%"
                clearable
                filterable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_scm') || '成品工厂'">
              <dict-select
                v-model="form.listScmCode"
                url="/master/common/dict/scm"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                style="width: 100%"
                clearable
                filterable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_cust') || '客户'">
              <dict-select
                v-model="form.listCustCode"
                url="/master/common/dict/customerSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                style="width: 100%"
                clearable
                filterable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_scmProductNo') || '工厂产品编号'"
            >
              <el-input
                v-model.trim="form.scmProductNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_customerProductNo') || '客人产品编号'"
            >
              <el-input
                v-model.trim="form.customerProductNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="5">
              <el-form-item :label="$l('form_label_moq') || '起订量'">
                <el-col :span="8">
                  <el-input-number
                    v-model="form.moqStart"
                    controls-position="right"
                    style="width: 100%"
                    :min="0"
                    :step="1"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                  />
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    v-model="form.moqEnd"
                    controls-position="right"
                    style="width: 100%"
                    :min="0"
                    :step="1"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                  />
                </el-col>
                <el-col :span="7">
                  <dict-select
                    :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                    v-model="form.moqUnit"
                    url="/master/common/dict/biz"
                    :body="{ dictType: 'moqUnit' }"
                    style="width: 100%"
                    clearable
                    filterable
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_brand') || '品牌'">
              <dict-select
                v-model="form.listBrandCode"
                url="/master/common/dict/brandSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                style="width: 100%"
                clearable
                filterable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_costMainType') || '成本类型'">
              <dict-select
                v-model="form.costMainType"
                url="/sys/common/dict/system"
                :body="{ dictType: 'costMainType' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                style="width: 100%"
                filterable
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="5">
              <el-form-item :label="$l('form_label_costPrice') || '成本价格'">
                <el-col :span="8">
                  <el-input-number
                    v-model="form.costPriceStart"
                    controls-position="right"
                    style="width: 100%"
                    :min="0"
                    :step="1"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                  />
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    v-model="form.costPriceEnd"
                    controls-position="right"
                    style="width: 100%"
                    :min="0"
                    :step="1"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                  />
                </el-col>
                <el-col :span="7">
                  <dict-select
                    v-model="form.costCurrency"
                    url="/sys/common/dict/system"
                    :body="{ dictType: 'currency' }"
                    :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                    style="width: 100%"
                    filterable
                    clearable
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_quotedMethod') || '报价方式'">
              <dict-select
                v-model="form.quotedMethod"
                url="/sys/common/dict/system"
                :body="{ dictType: 'quotedMethod' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="5">
              <el-form-item :label="$l('form_label_quotedPrice') || '建议报价'">
                <el-col :span="8">
                  <el-input-number
                    v-model="form.quotedPriceStart"
                    controls-position="right"
                    style="width: 100%"
                    :min="0"
                    :step="1"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                  />
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    v-model="form.quotedPriceEnd"
                    controls-position="right"
                    style="width: 100%"
                    :min="0"
                    :step="1"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                  />
                </el-col>
                <el-col :span="7">
                  <dict-select
                    v-model="form.quotedCurrency"
                    url="/sys/common/dict/system"
                    :body="{ dictType: 'currency' }"
                    :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                    style="width: 100%"
                    filterable
                    clearable
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_createBy') || '创建人'">
              <dict-select
                v-model="form.listCreateBy"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                style="width: 100%"
                clearable
                filterable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_modifyBy') || '修改人'">
              <dict-select
                v-model="form.listModifyBy"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                style="width: 100%"
                clearable
                filterable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="5">
              <el-form-item :label="$l('form_label_createDate') || '创建时间'">
                <el-col :span="24">
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.createDateStart"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      type="date"
                      value-format="yyyy-MM-dd"
                      style="width: 100%"
                    />
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.createDateEnd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      type="date"
                      value-format="yyyy-MM-dd"
                      style="width: 100%"
                    />
                  </el-col>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="5">
              <el-form-item :label="$l('form_label_modifyDate') || '修改时间'">
                <el-col :span="24">
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyDateStart"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      type="date"
                      value-format="yyyy-MM-dd"
                      style="width: 100%"
                    />
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyDateEnd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      type="date"
                      value-format="yyyy-MM-dd"
                      style="width: 100%"
                    />
                  </el-col>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const initForm = {
  keyword: '',
  categoryCode: '',
  masterCategoryCode: '',
  listSampleSetStatus: ['Y', 'S'],
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      categoryParams: { parentCode: 'ABSHome', isEcom: 'N' },
    }
  },
  created() {
    this.query()

    const _this = this
    this.$eventBus.$on('setproofing-table-reload', () => _this.query())
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
